<template>
    <div class="header-slide">
        <div class="header-info-main">
            <div class="logo">
                <img :src="PictureUrl" style="height: 45px;width: 45px;">
            </div>
            <div class="header-info">
                <h4>{{SectionName}} | {{ SubSectionName }}</h4>
                <p>{{ Description }}</p>
            </div>
        </div>
        <div class="type_reseau">
            <i :class="iconNetwork[Network]"></i>
            {{ Network }}
        </div>
    </div>
</template>

<script>

    
    export default {
        props: {
            SectionName: String,
            SubSectionName: String,
            Description: String,
            Network: String,
            PictureUrl: String
        },
        data() {
            return {
                iconNetwork : {
                    instagram : "fa-brands fa-instagram",
                    facebook : "fa-brands fa-facebook",
                    linkedin : "fa-brands fa-linkedin-in"
                }
            }
        },

        watch: {
            PictureUrl(newValue, oldValue) {
                
            }
        },
    }
</script>